var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 6.37504L5.1875 3.13129",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 10.5V5.49997C13.6248 5.28077 13.5669 5.06548 13.4572 4.8757C13.3475 4.68592 13.1898 4.52832 13 4.41872L8.625 1.91872C8.43498 1.80901 8.21942 1.75125 8 1.75125C7.78058 1.75125 7.56502 1.80901 7.375 1.91872L3 4.41872C2.81016 4.52832 2.65249 4.68592 2.54279 4.8757C2.43309 5.06548 2.37522 5.28077 2.375 5.49997V10.5C2.37522 10.7192 2.43309 10.9345 2.54279 11.1242C2.65249 11.314 2.81016 11.4716 3 11.5812L7.375 14.0812C7.56502 14.1909 7.78058 14.2487 8 14.2487C8.21942 14.2487 8.43498 14.1909 8.625 14.0812L13 11.5812C13.1898 11.4716 13.3475 11.314 13.4572 11.1242C13.5669 10.9345 13.6248 10.7192 13.625 10.5Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54395 4.84995L8.0002 8.0062L13.4564 4.84995",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.3V8",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.d7a2ced9129e7cdbe613642c01154417.svg";
export { ForwardRef as ReactComponent };